import { required } from '../../../helpers'
import RuleDepends from './RuleDepends'

export default class RequiredUnless extends RuleDepends {
  get ruleName () {
    return 'requiredUnless'
  }

  passes () {
    return required(this.value) || this.dataAttribute.split(',')
      .every(key => required(this.data[key]))
  }
}
